export const DEFAULT_SIZE = 100
export const STRIPES_COUNT = 5
export const STRIPE_MIN_HEIGHT = 20
export const START_DELAY = 0.1
